import { AsyncAdminRedirect } from 'pages/async';

export default [
  {
    name: 'Redirect to Admin',
    // eslint-disable-next-line react/display-name
    component: AsyncAdminRedirect,
  },
];
